import { IconProps } from "../../utils/global-types/global-types";

const WatchIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M7.358 9.499c.2-.078.429.092.386.301-.245.95-.795 1.2-1.47 1.2H5.73c-.675 0-1.23-.25-1.47-1.205-.04-.21.188-.378.387-.3.427.168.884.255 1.353.255.472 0 .931-.084 1.36-.251M7.745 2.2c.045.211-.188.383-.39.304A3.7 3.7 0 0 0 6 2.25c-.478 0-.935.09-1.354.256-.199.078-.428-.091-.386-.301C4.5 1.25 5.055 1 5.73 1h.545c.675 0 1.225.25 1.47 1.2M6 2.75a3.25 3.25 0 0 0-1.985 5.825h.005C4.57 9 5.255 9.25 6 9.25c.755 0 1.445-.255 1.995-.685H8A3.25 3.25 0 0 0 9.25 6 3.25 3.25 0 0 0 6 2.75m.965 4.44a.37.37 0 0 1-.265.11.37.37 0 0 1-.265-.11l-.7-.7a.38.38 0 0 1-.11-.265V4.83c0-.205.17-.375.375-.375s.375.17.375.375v1.24l.59.59a.377.377 0 0 1 0 .53"
    ></path>
  </svg>
);

export default WatchIcon;
